import React from 'react';

function NuovaPagina() {
  return (
    <div>
      <h1>Questa è la Nuova Pagina!</h1>
    </div>
  );
}

export default NuovaPagina;
